<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="row align-items-center" id="counter">
          <div class="col-lg-3 col-md-6">
            <div class="counter-box text-center px-4 py-5 mb-4 mb-lg-0">
              <div class>
                <img src="/assets/img/church.svg" />
                <h1 class="mb-2 mt-3">
                  <span class="counter-value mt-4" data-count="620">Sunday Service</span>
                </h1>
                <p>Every Sunday starting from 9:30am to 12:30pm</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="counter-box text-center px-4 py-5 mb-4 mb-lg-0">
              <div class>
                <img src="/assets/img/bible.svg" />
                <h1 class="mb-2 mt-3">
                  <span class="counter-value mt-4" data-count="1200">Bible Study</span>
                </h1>
                <p>Every Wednesday starting from 5:30pm to 6:30pm</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="counter-box text-center px-4 py-5 mb-4 mb-lg-0">
              <div class>
                <img src="/assets/img/group.svg" />
                <h1 class="mb-2 mt-3">
                  <span class="counter-value mt-4" data-count="450">Cell Groups</span>
                </h1>
                <p>Every Saturday starting from 5:00pm to 6:00pm</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="counter-box text-center px-4 py-5 mb-4 mb-lg-0">
              <div class>
                <img src="/assets/img/pray.svg" />
                <h1 class="mb-2 mt-3">
                  <span class="counter-value mt-4" data-count="450">Prayers</span>
                </h1>
                <p class="">Every Tuesday 5:30pm to 7:00pm</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="services" class="d-none">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-2 col-lg-2 offset-md-1 offset-lg-1 text-center mb-4">
            <img src="/assets/img/sunday.jpg" />
            <h4>Sunday Service</h4>
            <p class="text-center">Every Sunday starting from 10:00am to 12:00noon.</p>
          </div>
          <div class="col-md-2 col-lg-2 mb-4">
            <img src="/assets/img/bible.jpg" />
            <h4>Bible Study</h4>
            <p class="text-center">Every Tuesday starting from 5:30pm to 8:00pm.</p>
          </div>
          <div class="col-md-2 col-lg-2 mb-4">
            <img src="/assets/img/cell.png" />
            <h4>Cell Groups</h4>
            <p class="text-center">Every alternate Wednesday starting from 6:00pm to 8:00pm.</p>
          </div>
          <div class="col-md-2 col-lg-2 mb-4">
            <img src="/assets/img/prayer.png" />
            <h4>Prayers</h4>
            <p class="text-center">Every Thursday starting from 6:00pm to 7:00pm.</p>
          </div>
          <div class="col-md-2 col-lg-2 mb-4">
            <img src="/assets/img/worship.png" />
            <h4>Worship Experience</h4>
            <p class="text-center">Every last Thursday of the month starting from 6:00pm to 8:00pm.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "services"
};
</script>

<style lang='scss' scoped>
@import "../assets/css/variables.scss";

.section {
  position: relative;
  background-color: $tertiary-color;
}

h1 {
  font-size: 19px;
  color: $base-color;
  font-family: "Cabin", sans-serif !important;
  font-weight: 700;
  line-height: 23px;
}

p {
  color: $muted-white;
}

img {
  width: 45px;
  margin-bottom: 10px;
}

@media only screen and (max-width: 600px) {
    .counter-box {
      padding-bottom: 0 !important;
    }
  }
</style>